/* eslint-disable */
import { bus } from '../../main';
var $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import {
  mapGetters
} from 'vuex';
import { VueEditor } from "vue2-editor";
export default {
  name: 'author-details-edit',
  components: {
    VueEditor
  },
  props: [],
  data() {
    return {
      submitted: false,
      name: '',
      course:'',
      courseId:'',
      producerListDetails:'',
      removeProducerId:'',
      is_producer:'',
      gender:''

    }
  },
  computed: {
    ...mapGetters([
      'getAuhtorDetailsByIdDataState',
    ]),
    getProducerList() {
      this.$store.dispatch('getAuthorDetailsByIdFun', {
        id: this.$route.params.producerId
      }).then((response) => {
        this.name = this.$store.getters.getAuhtorDetailsByIdDataState.name
      })
    }
  },
  mounted() {
    this.getProducerList
    this.courseId = this.$route.params.courseId
  },
  methods: {
   createAuthorNamConfirmation(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          let data = {
              name: this.name,
              is_producer:true,
              gender: 'F',
              course:this.$route.params.courseId
          }
          this.$store.dispatch('updateAuthorFun', {
            data:{
              data: data,
              id: this.$route.params.producerId
            }
          })
            .then((res) => {
              toast.success(res.data.msg);
              this.$router.push('/course/' + this.$route.params.courseId + '/producer/create/')
            })
            .catch((err) => { })
          return
        }
      });
    }
  }
}